import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DesyAngularModule } from 'desy-angular';
import { uppercaseAll } from '@/app/pipe/uppercaseAll.pipe';
import { getCommonCardStateColor } from '../../../utils/card-state-color.utils';

@Component({
  selector: 'app-home-card',
  standalone: true,
  imports: [DesyAngularModule, RouterModule, CommonModule, uppercaseAll],
  templateUrl: './home-card.component.html',
  styleUrls: ['./home-card.component.scss'],
})
export class HomeCardComponent {
  @Input() title = '';
  @Input() count: string | number = '';
  @Input() description = '';
  @Input() textUrl = '';
  @Input() url = '';

  private _state = '';
  @Input() set state(value: string) {
    this._state = value;
    this.color = getCommonCardStateColor(value);
  }
  get state(): string {
    return this._state;
  }

  color = '';
}
